module.exports = __webpack_public_path__ + "static/flags/SN-d4666ecf39e13e026932d728bfdf6007.gif";